import { useGetDocument } from "@hooks";
import { TextField, Typography } from "@mui/material";
import { RegulatoryFunctionalGroup, RegulatoryTypeEnum } from "@types";
import { useParams } from "react-router-dom";
import GenericSearchSelect from "src/components/GenericSearchSelect";
import type { LocalData } from "../../authorContent/AuthorContent";

const DocMetadata = ({
  docId,
  localData,
  setLocalData,
}: {
  docId: string;
  localData: LocalData;
  setLocalData: React.Dispatch<React.SetStateAction<LocalData>>;
}) => {
  const { orgId = "" } = useParams();
  const { data: document } = useGetDocument(orgId, docId);

  const regulatoryFunctionalGroupNotSaved =
    document && !document.regulatoryFunctionalGroup;

  const regulatoryTypeNotSaved = document && !document.regulatoryType;

  const titleNotSaved = document && !document.title;

  const handleSelect = ({
    key,
    value,
  }: {
    key: "regulatoryType" | "regulatoryFunctionalGroup" | "title";
    value: string | null;
  }) => {
    if (value) {
      setLocalData({
        ...localData,
        documentMetadata: {
          ...localData.documentMetadata,
          [key]: value,
        },
      });
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalData({
      ...localData,
      documentMetadata: {
        ...localData.documentMetadata,
        title: e.target.value,
      },
    });
  };

  return (
    <div>
      <Typography variant="body1" fontWeight="bold" className="pb-2">
        Regulatory Document Information
      </Typography>
      <div className="flex gap-3 items-end pb-3">
        {regulatoryFunctionalGroupNotSaved && (
          <GenericSearchSelect
            value={localData.documentMetadata.regulatoryFunctionalGroup}
            setValue={(value) =>
              handleSelect({
                key: "regulatoryFunctionalGroup",
                value: value,
              })
            }
            options={Object.values(RegulatoryFunctionalGroup)}
            label="Functional Group"
          />
        )}
        {regulatoryTypeNotSaved && (
          <GenericSearchSelect
            value={localData.documentMetadata.regulatoryType}
            setValue={(value) =>
              handleSelect({
                key: "regulatoryType",
                value: value,
              })
            }
            options={Object.values(RegulatoryTypeEnum)}
            label="Document Type"
          />
        )}
      </div>
      {titleNotSaved && (
        <TextField
          label="Document Name"
          size="small"
          fullWidth
          value={localData.documentMetadata.title}
          onChange={handleChange}
        />
      )}
    </div>
  );
};

export default DocMetadata;
